import { Column, ColumnFilterElementTemplateOptions } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect, useState } from 'react'
import { displayDateFormat } from '../../../service/shared.service';
import { toast } from 'react-toastify';
import { APIResponseEntity } from '../../../interface/api-responce';
import { APIActiveUsers, } from '../../../service/api-service';
import Loader from '../../../components/loader';
import { AxiosResponse } from 'axios';
import { toastOptObj } from '../../../utils/constants';
import moment from 'moment-timezone';
import { OnlineUsersEntity } from '../../../interface/online-users'
import { InputText } from 'primereact/inputtext';
import PrimePaginator from '../../../components/prime-paginator';
import { PaginateRespEntity } from '../../../interface';
import { IsNullOrEmptyArray } from '../../../utils/null-check';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { Calendar } from 'primereact/calendar';
import { FilterOrderDatesEntity } from '../../../interface/order';
import { Dropdown } from 'primereact/dropdown';
import { getLocalStorageItem, setLocalStorageItem } from "../../../service/storage-service";
import { StorageKeyEnum } from "../../../utils/enum"
export default function OnlineUsersPage() {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [totalPageCount, setTotalPageCount] = useState(0);

    const fromToDateMinDate = new Date("2000-01-01");

    const [filterReq, setFilterReq] = useState<OnlineUsersEntity>({
        pageSize: 10,
        pageNumber: 0,
        APICallCount: 0,
        signInFrom: ""
    });

    const [filterDates, setFilterDates] = useState<FilterOrderDatesEntity>({
        fromDate: null, toDate: null
    });

    const signInFromOptions = [
        { label: "Website", value: "website" },
        { label: "WebApp", value: "webapp" }
    ];
    const [activeUsers, setActiveUsers] = useState<any[]>([]);

    useEffect(() => {
        const storedFilter = getLocalStorageItem(
            StorageKeyEnum.ONLINE_USERS_FILTER_KEY
        );

        if (storedFilter) {
            setFilterReq(JSON.parse(storedFilter));
        }
    }, []);

    const fetchActiveUserDetails = async (): Promise<void> => {

        setIsLoading(true);

        const resp: AxiosResponse<APIResponseEntity> = await APIActiveUsers(filterReq);

        if (!resp || resp.status !== 200 || !resp.data) {
            toast.error("Failed to fetch active users", { ...toastOptObj });
            setIsLoading(false);
            return;
        }

        const axiosResp: APIResponseEntity = resp.data;

        if (axiosResp.statusCode !== 200 || !axiosResp.data) {
            toast.error(axiosResp.message, { ...toastOptObj });
            setIsLoading(false);
            return;
        }

        const paginateResp: PaginateRespEntity = axiosResp.data;

        setActiveUsers(paginateResp.data || []);
        setTotalPageCount(paginateResp.totalCount);
        setIsLoading(false);
    };
    useEffect(() => {
        fetchActiveUserDetails();
        const interval = setInterval(() => {
            fetchActiveUserDetails();
        }, 5000);

        return () => clearInterval(interval);
    }, [filterReq]);

    useEffect(() => {
        setLocalStorageItem(
            StorageKeyEnum.ONLINE_USERS_FILTER_KEY,
            JSON.stringify(filterReq)
        );
    }, [filterReq]);

    useEffect(() => {
        if (filterDates.fromDate) {
            const createFromDate: string = moment(filterDates.fromDate).format('YYYY-MM-DD');
            setFilterReq(prev => ({ ...prev, createFromDate, pageNumber: 0, APICallCount: prev.APICallCount! + 1 }));
        }
    }, [filterDates.fromDate]);

    useEffect(() => {
        if (filterDates.toDate) {
            const createToDate: string = moment(filterDates.toDate).format('YYYY-MM-DD');
            setFilterReq(prev => ({ ...prev, createToDate, pageNumber: 0, APICallCount: prev.APICallCount! + 1 }));
        }
    }, [filterDates.toDate]);

    const dateBodyTemplate = (rowData: any) => {
        return moment.tz(rowData.createdAt, "Asia/Kolkata").fromNow();
    };

    const filterTemplateUserName = (
        options: ColumnFilterElementTemplateOptions
    ) => {
        return (
            <InputText
                value={filterReq.userName}
                placeholder="Search by name"
                onChange={(e) =>
                    setFilterReq((prev) => ({
                        ...prev,
                        userName: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1,
                    }))
                }
            />
        );
    };

    const filterTemplateOfficeName = (
        options: ColumnFilterElementTemplateOptions
    ) => {
        return (
            <InputText
                value={filterReq.officeName}
                placeholder="Search by office name"
                onChange={(e) =>
                    setFilterReq((prev) => ({
                        ...prev,
                        officeName: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1,
                    }))
                }
            />
        );
    };

    const filterTemplateEmailAddress = (
        options: ColumnFilterElementTemplateOptions
    ) => {
        return (
            <InputText
                value={filterReq.emailAddress}
                placeholder="Search by email Address"
                onChange={(e) =>
                    setFilterReq((prev) => ({
                        ...prev,
                        emailAddress: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1,
                    }))
                }
            />
        );
    };

    const filterTemplateSignInFrom = (
        options: ColumnFilterElementTemplateOptions
    ) => {
        return (
            <Dropdown
                value={filterReq.signInFrom}
                options={signInFromOptions}
                placeholder="Select Platform"
                onChange={(e) =>
                    setFilterReq((prev) => ({
                        ...prev,
                        signInFrom: e.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount! + 1,
                    }))
                }
                showClear
                className="w-100"
            />
        );
    };

    const filterTemplateCreateDate = (options: ColumnFilterElementTemplateOptions) => {
        return (
            <div className="d-flex gap-1">
                <Calendar
                    value={filterDates.fromDate}
                    dateFormat="dd/mm/yy"
                    placeholder='From'
                    minDate={fromToDateMinDate}
                    maxDate={new Date()}
                    onChange={(e) => setFilterDates({ ...filterDates, fromDate: e.target.value })}
                />

                <Calendar
                    value={filterDates.toDate}
                    placeholder='To'
                    minDate={filterDates.fromDate ? filterDates.fromDate : fromToDateMinDate}
                    maxDate={new Date()}
                    dateFormat="dd/mm/yy"
                    onChange={(e) => setFilterDates({ ...filterDates, toDate: e.target.value })}
                />
            </div>
        );
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFilterReq({ ...filterReq, pageSize: event.rows, pageNumber: event.page });
    };


    const resetFilters = (): void => {
        setFilterReq({
            pageSize: 10,
            pageNumber: 0,
            APICallCount: 0,
            signInFrom: "",
            emailAddress: "",
            userName: "",
            officeName: "",
            createFromDate: "",
            createToDate: ""
        });

        setFilterDates({
            fromDate: null,
            toDate: null
        });

        localStorage.removeItem(StorageKeyEnum.ONLINE_USERS_FILTER_KEY);
    };

    return (

        <>
            <Loader isLoading={isLoading} />
            <div className="content-wrapper">
                <div className='col-12'>
                    <div className='row'>
                        <div className="col-lg-12 col-md-12 mb-md-0 mb-3">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <h4 className="card-title">Online Users</h4>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <span className='resetFilters text-primary' onClick={resetFilters}>
                                                Reset Filters
                                            </span>
                                        </div>
                                    </div>
                                    <div className='col mt-3'>
                                        <DataTable value={activeUsers} filterDisplay="row">
                                            <Column field="officeName" header="OFFICE NAME" frozen
                                                showFilterMenu={false} filterElement={filterTemplateOfficeName}
                                                filter ></Column>
                                            <Column field="userFullName" header="NAME" frozen
                                                showFilterMenu={false}
                                                filter filterElement={filterTemplateUserName}></Column>
                                            <Column field="emailAddress" header="USER ID" frozen
                                                showFilterMenu={false}
                                                filter filterElement={filterTemplateEmailAddress}></Column>
                                            <Column
                                                field="signInFrom"
                                                header="PLATFORM"
                                                showFilterMenu={false}
                                                filter
                                                filterElement={filterTemplateSignInFrom}
                                            />
                                        </DataTable>
                                    </div>
                                    {
                                        !IsNullOrEmptyArray(activeUsers) && <PrimePaginator
                                            onPageChange={onPageChange}
                                            pageNumber={filterReq.pageNumber}
                                            pageSize={filterReq.pageSize}
                                            totalRecords={totalPageCount}
                                        />
                                    }
                                </div>
                            </div >
                        </div >
                    </div >
                </div >
            </div>
        </>
    )
}
